(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-brands"]) return;
  try {
    
  if (!customElements.get('brand-directory')) {
    customElements.define('brand-directory', class BrandDirectory extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.buttons = [...this.querySelectorAll('[data-brand-filter]')];
        this.groups = [...this.querySelectorAll('[data-brand-group]')];
        this.status = this.querySelector('[data-brand-filter-status]');
        this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button.dataset.brandFilter)));
      }

      filter(letter) {
        this.classList.toggle('is-filtered', letter !== 'all');
        this.buttons.forEach((button) => {
          const active = button.dataset.brandFilter === letter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.groups.forEach((group) => {
          group.hidden = letter !== 'all' && group.dataset.brandGroup !== letter;
        });
        if (this.status) {
          this.status.textContent = letter === 'all'
            ? this.dataset.statusAll
            : this.dataset.statusLetter.replace('[letter]', letter);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
